import React, { useEffect, useState } from "react";
import Joyride, { STATUS } from "react-joyride";

const AppTour = ({ activeTab, hasItems, forceStart, onTourEnd }) => {
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (forceStart) {
      setRun(false);
    }

    const timer = setTimeout(() => {
      const seenGeneral = localStorage.getItem("tour_seen_general");

      if ((forceStart || !seenGeneral) && activeTab === "tab0") {
        setSteps([
          {
            target: ".tour-inbox-tabs",
            content: "Welcome to your Inbox! Switch between your general Practice chats, conversations Assigned directly to you, your Archives, and Call History.",
            placement: "bottom",
            disableBeacon: true,
            disableScrolling: true 
          },
          {
            target: ".tour-tab-practice",
            content: "Welcome to your Inbox! This is the Practice tab, where you can see all general conversations available to your clinic.",
            placement: "bottom",
            disableBeacon: true,
            disableScrolling: true 
          },
          {
            target: ".tour-tab-assigned",
            content: "This is the Assigned tab. Any conversations specifically assigned to you for direct action or follow-up will appear here.",
            placement: "bottom",
            disableBeacon: true,
            disableScrolling: true 
          },
          {
            target: ".tour-tab-archived",
            content: "The Archived tab stores past conversations that have been wrapped up. You can easily access historical communication here.",
            placement: "bottom",
            disableBeacon: true,
            disableScrolling: true 
          },
          {
            target: ".tour-tab-call-history",
            content: "Lastly, the Call History tab logs your past audio and video calls for easy reference.",
            placement: "bottom",
            disableBeacon: true,
            disableScrolling: true 
          },
          {
            target: ".tour-inbox-filters",
            content: "Looking for a specific patient? Use these filters to narrow down your view by Clinic Location, Care Team, or search by name.",
            placement: "bottom",
            disableBeacon: true,
            disableScrolling: true 
          },
          {
            target: ".tour-action-archive",
            content: "Done with this conversation? Click the Archive button to hide it from your active inbox.",
            placement: "top",
            disableBeacon: true
          },
          {
            target: ".tour-action-assign",
            content: 'Click here to Assign this chat specifically to yourself. It will move to your "Assigned" tab.',
            placement: "top",
            disableBeacon: true
          },
          {
            target: ".tour-start-chat-fab",
            content: "Need to start a new conversation? Click here to reach out to a Patient, a Team, or ConnectCare support.",
            placement: "left",
            disableBeacon: true,
            disableScrolling: true 
          }
        ]);
        setRun(true);
        return;
      }

      const seenAssigned = localStorage.getItem("tour_seen_assigned");
      if ((forceStart || !seenAssigned) && activeTab === "tab1" && hasItems) {
        setSteps([
          {
            target: ".tour-action-move",
            content: "Click here to move a conversation back into the general Practice channel so other providers can see it.",
            placement: "top",
            disableBeacon: true
          },
          {
            target: ".tour-change-status-fab",
            content: "Need to step away? Toggle your status to Offline here to pause new patient assignments.",
            placement: "left",
            disableBeacon: true,
            disableScrolling: true 
          },
        ]);
        setRun(true);
        return;
      }

      if (activeTab === "tab2" && hasItems) {
        let archivedSteps = [];
        const seenArchivedBasic = localStorage.getItem("tour_seen_archived_basic");
        const seenArchivedBy = localStorage.getItem("tour_seen_archived_by");
        const seenAssignedRed = localStorage.getItem("tour_seen_assigned_red");

        if (forceStart || !seenArchivedBasic) {
          archivedSteps.push({
            target: ".tour-action-unarchive",
            content: "Need this conversation back? Click here to Unarchive it and return it to your active chats.",
            placement: "top",
            disableBeacon: true
          });
        }

        if ((forceStart || !seenArchivedBy) && document.querySelector(".tour-archived-by-text")) {
          archivedSteps.push({
            target: ".tour-archived-by-text",
            content: 'Notice the "Archived By" text? This tells you which provider wrapped up this conversation.',
            placement: "bottom",
            disableBeacon: true
          });
        }

        if ((forceStart || !seenAssignedRed) && document.querySelector(".tour-assigned-red-text")) {
          archivedSteps.push({
            target: ".tour-assigned-red-text",
            content: 'If you see "Assigned to...", it means another provider assigned this chat to themselves. It stays in your Archives for your records, but is active in their Assigned tab!',
            placement: "bottom",
            disableBeacon: true
          });
        }

        if (archivedSteps.length > 0) {
          setSteps(archivedSteps);
          setRun(true);
          return;
        }
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [activeTab, hasItems, forceStart]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);

      if (onTourEnd) {
        onTourEnd();
      }

      if (activeTab === "tab0") localStorage.setItem("tour_seen_general", "true");
      if (activeTab === "tab1") localStorage.setItem("tour_seen_assigned", "true");
      if (activeTab === "tab2") {
        localStorage.setItem("tour_seen_archived", "true");
        localStorage.setItem("tour_seen_archived_basic", "true");
        localStorage.setItem("tour_seen_archived_by", "true");
        localStorage.setItem("tour_seen_assigned_red", "true");
      }
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
            scrollToFirstStep={true}
      hideCloseButton={true}
      scrollOffset={250} 
      
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: "#000000",
          textColor: "#000000",
          zIndex: 9999,
        },
        tooltip: {
          borderRadius: "8px",
          padding: "20px",
        },
        buttonNext: {
          backgroundColor: "#3c8138",
          borderRadius: "4px",
        },
        buttonBack: {
          color: "#3c8138",
        },
      }}
    />
  );
};

export default AppTour;